import { Chip, ChipProps, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"

import { useTranslation } from "providers/i18n"

export const VatRefundChip: React.FC<ChipProps> = ({ sx = {}, ...props }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { root } = theme.components?.[`VatRefundChip`]?.styleOverrides || {}
  return <Chip label={t("VAT Refund")} sx={deepmerge(root, sx)} {...props} />
}
